// extracted by mini-css-extract-plugin
export default {"title":"GoodsItem_title__BjOz4"};